import { ActionTypes } from '../actions/fileActions';

const initialState = {
  busy: false,
  filePreview: {},
};

// TODO: this needs refactoring - the structure of filePreview
// should be consistent and if it cant then additional fields should be
// added for different file types/different upload states
const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FILE_UPLOADING: {
      const newFilePreview = {};
      newFilePreview[action.payload] = { busy: true };
      const filePreview = Object.assign(state.filePreview, newFilePreview);
      return Object.assign({}, state, { filePreview });
    }
    case ActionTypes.FILE_TEMP_UPLOADED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({}, state, { filePreview });
    }
    case ActionTypes.FILE_UPLOADED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({}, state, { filePreview });
    }
    case ActionTypes.FILE_CROPPED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({}, state, { filePreview });
    }
    case ActionTypes.UPLOAD_INTERRUPTED: {
      return Object.assign({},
        state,
        {
          busy: false,
          filePreview: {
            busy: false,
          }
        }
      );
    }
    default:
      return state;
  }
};

export default fileReducer;



// WEBPACK FOOTER //
// ./src/cards/reducers/file.js